import { common_urls, common_urls_cws2 } from 'src/environments/environment';
import { CWS2_ROUTES } from 'src/app/cws2.0/shared/cws2-routes.constants';

export const ADDRESS_TELEPHONE_CHANGE_BASE_ROUTE = CWS2_ROUTES.ADDRESS_TELEPHONE_CHANGE;

export const ADDRESS_TELEPHONE_CHANGE_API = {
  LOAD: `${common_urls_cws2.bffBaseUrl_mvp3}/load/address-tel-change`,
  SUBMIT: `${common_urls_cws2.bffBaseUrl_mvp3}/submit/address-tel-change`,
} as const;

export const ADDRESS_TELEPHONE_CHANGE_URLS = {
  contactUrl: `${common_urls.cwsBaseUrl}/emailinquiry?from=home`,
  cwsHomeUrl: `${common_urls.cwsBaseUrl}/home?From=auth&cws=1`,
} as const;

export const ADDRESS_TELEPHONE_CHANGE_STEPPER_TRANSLATION_PREFIX = 'addressTelephoneChange.stepper.';
export const ADDRESS_TELEPHONE_CHANGE_SCREEN_TYPE = ADDRESS_TELEPHONE_CHANGE_BASE_ROUTE;

export const ADDRESS_TELEPHONE_CHANGE_STEP_NAMES = ['step1', 'step2'] as const;

export const ADDRESS_TELEPHONE_CHANGE_ROUTES = {
  DETAILS: 'details',
  CONFIRMATION: 'confirmation',
  COMPLETION: 'completion',
} as const;

export const ADDRESS_TELEPHONE_CHANGE_STEP_INDEX = {
  DETAILS: 0,
  CONFIRMATION: 1,
  COMPLETION: 2,
} as const;
